import React from 'react';
import { IVideoContent } from '../Helpers/contentSectionConfig';
import { extractYouTubeVideoId } from '../Helpers/youtube';

// A content section that embeds a single video. YouTube URLs (any of the forms
// extractYouTubeVideoId recognizes) render as the standard responsive embed iframe — identical
// behaviour to the legacy section-cell video. A direct file URL (.mp4/.webm) renders via a native
// <video controls>. Anything else renders nothing.
const VideoSection: React.FC<{ config: IVideoContent | null }> = ({ config }) => {
    const url = config?.url?.trim();
    if (!url) return null;

    const youTubeId = extractYouTubeVideoId(url);
    // Case-insensitive, ignore any query string on the URL when sniffing the file extension.
    const isDirectFile = /\.(mp4|webm)(\?|#|$)/i.test(url);

    // The section title (rendered by ContentSection) is the only heading — the video has no
    // per-video title of its own.
    let player: React.ReactNode = null;
    if (youTubeId) {
        // 16:9 responsive frame: a padding-top box the absolutely-positioned iframe fills. Matches the
        // legacy iframe's allow/allowFullScreen flags so embedded playback behaves the same.
        player = (
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                <iframe
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                    src={`https://www.youtube.com/embed/${youTubeId}`}
                    title="Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </div>
        );
    } else if (isDirectFile) {
        player = (
            <video controls src={url} style={{ width: '100%', maxHeight: '70vh', display: 'block', borderRadius: 8 }} />
        );
    } else {
        return null;
    }

    return <div>{player}</div>;
};

export default VideoSection;
